module.exports = __webpack_public_path__ + "static/media/share.3c895087.svg";